<template>
    <div>
        <form action="/">
            <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索名称/编号" left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
            </van-search>
        </form>
        <div class="add-customer flex flex-between">
            <div> <span>产品总额：</span>
                <span class="add-customer-number">{{ totalProductBalanceAmount }}</span>
                <span>万</span>
                <span class="sheets">总数量：</span>
                <span class="add-customer-number">{{ totalProductCount }}</span>
                <span>整包</span>
            </div>
            <div class="select-item ml-30 flex flex-between flex-y-center" @click="selectSortPopup">
                <div class="select-tit">{{ checkedSort && checkedSort.name }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
        </div>
        <div class="list-box">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                <!-- 下拉刷新 -->
                <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="getProductList" :offset="20" :immediate-check="false">

                    <div class="customer-list" v-for="(item, index) in productList" :key="index" @click="toDetail(item)">
                        <div class="flex-y-center">
                            <div class="customer-info flex-1">
                                {{ item.productName }}
                            </div>
                            <img class="arrow_right" referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/arrow_right.png" alt="" />
                        </div>
                        <div class="customer-remark flex-start flex-y-center">
                            <div class="flex-between flex-y-center mr-60">
                                <span class="sale-name">资产：</span>
                                <span class="sale-number">{{ item.productPropertyAmount }}万</span>
                            </div>
                            <div class="flex-between flex-y-center">
                                <span class="sale-name">数量：</span>
                                <span class="sale-number">{{ item.concat }}</span>
                            </div>
                        </div>
                        <div class="customer-remark flex-between flex-y-center">
                            <div class="flex-between flex-y-center">
                                <span class="sale-name">持有顾客数：</span>
                                <span class="sale-number">{{ item.customerCount }}</span>
                            </div>
                        </div>
                    </div>
                </van-list>

            </van-pull-refresh>

        </div>
        <van-popup v-model="showSortPopup" round position="bottom" closeable class="popup">
            <picker title="总资产排序" v-model="checkedSort" :list="sortList" @change="onSortChange"></picker>
        </van-popup>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Search, Toast } from "vant";

    import Picker from '@/components/Picker';


    export default {
        name: "productBalanceAssets",
        components: {
            [Search.name]: Search, Picker
        },
        data() {
            return {
                productList: [],    // 产品资产列表
                searchStr: "",
                page: 1,
                sortList: [],//排序列表
                checkedSort: null, //资产排序
                totalProductBalanceAmount: 0,//总额
                totalProductCount: 0,//总数量
                showSortPopup: false,//排序弹窗
                loading: false,    // 加载
                finished: false,    // 结束加载
                refreshing: false,   // 刷新
            };
        },
        computed: {
        },
        mounted() {
            this.init()
        },
        methods: {
            async init() {
                await this.getSortList()
                this.getProductList()
            },
            getProductList() {
                this.loading = true
                let params = {
                    limit: 10,
                    page: this.page,
                    propertySortType: this.checkedSort.id,
                    searchStr: this.searchStr,
                    id: this.$route.query.id,
                    storeId: this.$route.query.storeId
                }
                request({
                    url: `/debt/storeProductProperty`,
                    method: "get",
                    params: params
                })
                    .then((res) => {
                        this.totalProductBalanceAmount = res.data.totalProductBalanceAmount;
                        this.totalProductCount = res.data.totalProductCount;
                        this.productList = this.page == 1 ? res.data.productPropertyPage.list : this.productList.concat(res.data.productPropertyPage.list);
                        this.page += 1;
                        this.total = res.data.productPropertyPage.total;

                    }).catch((error) => {
                        this.finished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.loading = false;
                        this.refreshing = false;
                        if (this.productList.length >= this.total) {
                            this.finished = true;
                        }
                    });
            },
            // 获取排序列表
            getSortList() {
                return request({
                    url: "/debt/servicePropertySortList",
                    method: "get",
                })
                    .then((res) => {
                        this.sortList = res.data
                        this.checkedSort = this.sortList[0] //默认全部
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            onRefresh() {
                this.page = 1
                this.finished = false;
                this.loading = true;
                this.productList = [];
                this.refreshing = false;
                this.getProductList();
            },
            //查看详情
            toDetail(e) {
                this.$router.push({
                    name: "productBalanceDetail", query: {
                        prodSku: e.prodSku, productName: e.productName, isPacking: e.isPacking, prodUnit: e.prodUnit, id: this.$route.query.id,
                        storeId: this.$route.query.storeId
                    }
                });
            },
            //搜索
            onSearch() {
                this.onRefresh()
            },
            //清除搜索
            selClear() {
                this.searchStr = "";
                this.onRefresh()
            },
            // 弹窗
            selectSortPopup() {
                this.showSortPopup = true
            },
            // 筛选相关
            onSortChange(data) {
                this.showSortPopup = false
                this.checkedSort = data
                this.onRefresh()
            },
        },
    };
</script>

<style scoped lang="less">
    ::-webkit-scrollbar {
        display: none;
    }

    .mr-30 {
        margin-right: 30px;
    }

    .mr-60 {
        margin-right: 60px;
    }

    .add-customer {
        font-weight: 400;
        color: #66757f;
        font-size: 26px;
        line-height: 37px;
        margin: 0 0 40px 31px;
    }

    .customer-info {
        height: 42px;
        font-size: 30px;
        font-weight: 700;
        color: #35434c;
        line-height: 42px;
        margin-top: 10px;
        margin-bottom: 30px;
    }

    .sheets {
        margin-left: 30px;
    }

    .add-customer-number {
        color: #f65252;
        font-weight: 700;
        font-size: 30px;
    }

    .list-box {
        width: 100%;
        height: calc(100vh - 245px);
        justify-content: space-between;
        margin: 0 auto 0;
        position: relative;
        z-index: 1;
        overflow-y: auto;
        padding: 0 30px 30px 30px;
    }

    .customer-list {
        width: 690px;
        height: 212px;
        background: #fafafe;
        border-radius: 20px;
        padding: 20px;
        margin-bottom: 20px;
    }

    .customer-name {
        min-width: 60px;
        height: 42px;
        font-size: 30px;
        color: #35434c;
        line-height: 42px;
        font-weight: 700;
    }

    .churn-time {
        height: 37px;
        font-size: 26px;
        color: #a0acb5;
        line-height: 37px;
        margin-top: 11px;
    }

    .nursing-edit-box {
        margin: 37px 0 0 163px;
    }

    .arrow_right {
        width: 15px;
        height: 26px;
    }

    .card-image {
        height: 34px;
        width: 90px;
        margin: 24px 0 0 10px;
    }

    .customerHeadPortrait {
        width: 90px;
        height: 90px;
        border-radius: 45px;
    }

    .customer-remark {
        padding: 0 0 15px 0;
    }

    .sale-name {
        height: 40px;
        font-size: 28px;
        color: #a0acb5;
        line-height: 40px;
    }

    .sale-number {
        height: 40px;
        font-size: 28px;
        font-weight: 700;
        color: #35434c;
        line-height: 40px;
    }

    .select-item {
        margin-right: 30px;

        .select-tit {
            font-size: 28px;
            color: #35434c;
        }

        .select-arrow {
            transform: rotate(90deg);
            font-size: 24px;
            margin-left: 10px;
        }
    }

    .van-pull-refresh {
        min-height: 100%;
    }

    :deep(.search-button.van-search) {
        padding: 30px 30px 30px 30px;
    }

    :deep(.search-button .van-icon) {
        font-size: 28px;
    }

    :deep(.search-button .van-search__content) {
        padding-left: 20px !important;
    }

    :deep(.search-button .van-field__left-icon) {
        color: #c8c9cc !important;
        padding: 3px 20px 0 0 !important;
        margin-right: 0 !important;
    }

    :deep(.van-icon__image) {
        height: 28px;
        display: inline-block;
    }

    :deep(.van-field__control) {
        font-size: 28px !important;
    }
</style>
